import React from 'react';
import { V } from '../../../utils/theme';
import { Switch } from '../../../components/FullSheet';
import { orgApi, orgErr, errorMessage } from '../../../utils/org';

// ─── Shared bits for the super-admin Organizations panel ───
export const STATUS_COLOR = { active: '#22c55e', suspended: '#f59e0b', closed: '#ef4444' };

// Every call goes through here: super-admin actions on a tenant carry `org_id` in the
// body (SA_MAY_TARGET in the API synthesises an owner context for that org).
export function useApi() {
  return async (action, payload = {}) => {
    try { return { ok: true, data: await orgApi(action, payload) }; }
    catch (e) { const er = orgErr(e); return { ok: false, err: er, msg: errorMessage(er) + (er.detail ? ` — ${er.detail}` : '') }; }
  };
}

export const td = { paddingTop: 8, paddingBottom: 8, paddingLeft: 8, paddingRight: 8, borderBottom: `1px solid rgba(128,128,128,0.12)`, whiteSpace: "nowrap" };
export const StatusPill = ({ status }) => <span style={{ fontSize: 10, fontWeight: 700, color: STATUS_COLOR[status] || V.text3, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8, borderRadius: 8, background: `${STATUS_COLOR[status] || '#888'}18`, textTransform: "uppercase", letterSpacing: ".04em" }}>{status}</span>;
export const memberPill = (status) => (status === 'active' ? 'active' : status === 'removed' ? 'closed' : 'suspended');

export const ToggleRow = ({ label, on, onChange, hint, disabled, testId }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, paddingTop: 8, paddingBottom: 8 }} data-testid={testId}>
    <div style={{ minWidth: 0 }}><div style={{ fontSize: 13, color: V.text }}>{label}</div>{hint && <div style={{ fontSize: 10, color: V.text3 }}>{hint}</div>}</div>
    <Switch on={on} onChange={onChange} label={label} disabled={disabled} />
  </div>
);

export const SmallLabel = ({ children, style = {} }) => <div style={{ fontSize: 10, color: V.text3, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 4, fontWeight: 600, ...style }}>{children}</div>;
export const inputStyle = (extra = {}) => ({ minHeight: 36, background: V.inputBg, border: `1px solid ${V.cardBorder}`, borderRadius: 8, paddingLeft: 8, paddingRight: 8, color: V.text, fontSize: 13, fontFamily: V.font, outline: "none", boxSizing: "border-box", ...extra });
// Compact labelled input for filter bars (Field is 16px/44px tall — too big for a row of four)
export const MiniField = ({ label, value, onChange, type = 'text', placeholder, onEnter, list, style = {} }) => (
  <div style={{ display: "flex", flexDirection: "column", minWidth: 0, ...style }}>
    <SmallLabel>{label}</SmallLabel>
    <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} aria-label={label} list={list}
      onKeyDown={e => { if (e.key === 'Enter' && onEnter) onEnter(); }} style={inputStyle({ width: "100%" })} />
  </div>
);
export const MiniSelect = ({ label, value, onChange, options, style = {} }) => (
  <div style={{ display: "flex", flexDirection: "column", minWidth: 0, ...style }}>
    <SmallLabel>{label}</SmallLabel>
    <select value={value} onChange={e => onChange(e.target.value)} aria-label={label} style={inputStyle({ width: "100%", WebkitAppearance: "none" })}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </div>
);

// Tiny inline action button (row actions in the members / invites lists)
export const RowBtn = ({ children, onClick, disabled, color = V.accent, ariaLabel }) => (
  <button type="button" onClick={disabled ? undefined : onClick} disabled={disabled} aria-label={ariaLabel}
    style={{ fontSize: 11, fontWeight: 700, color, background: `${color}14`, border: `1px solid ${color}28`, borderRadius: 8, paddingTop: 4, paddingBottom: 4, paddingLeft: 9, paddingRight: 9, cursor: disabled ? "default" : "pointer", opacity: disabled ? .5 : 1, fontFamily: V.font, whiteSpace: "nowrap", WebkitTapHighlightColor: "transparent" }}>
    {children}
  </button>
);
